import React from 'react';
import { useNavigate } from 'react-router-dom';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, { Arquivo, Botao, CaixaDeTexto, Campo } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import Comunicado from 'Interface/Comunicados';
import { useAdicionarComunicadoMutation } from 'View/Service/Default/Comunicados';

const regras = object({
  assunto: string().required('Obrigatório'),
  mensagem: string().required('Obrigatório'),
});

const Adicionar = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const [adicionarComunicado] = useAdicionarComunicadoMutation();

  const enviar = async (dados: Comunicado): Promise<void> => {
    try {
      await adicionarComunicado(dados).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      navegacao('/comunicados');
    } catch (error) {
      toast({
        titulo: 'Erro ao adicionar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Adicionando comunicado"
        descricao="Preencha o formulário e clique em enviar para adicionar o comunicado"
      />
      <Form onSubmit={enviar} regras={regras}>
        <div className="row justify-content-center">
          <div className="col-md-5">
            <div className="bg-white shadow-sm rounded p-4">
              <Campo name="assunto" rotulo="Assunto" />
              <CaixaDeTexto name="mensagem" rotulo="Mensagem" />
              <Arquivo name="arquivo" />
              <div className="mt-5">
                <Botao>Enviar</Botao>
                <BotaoLink tema="light" to="/comunicados" className="ms-2">
                  Cancelar
                </BotaoLink>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </LayoutDefault>
  );
};

export default Adicionar;
